"use strict";

var moduleName = "similar-products";

module.exports = function () {
	$(".jsSimilarProducts").each(function () {
		if($.data(this, moduleName + "-init")) return;
		$.data(this, moduleName + "-init", true);



		//
		// Похожие товары
		//

		var visibleSimilarProducts = $(".jsSimilarProductsListItem:visible").length;

		$(".jsSimilarProductsBtnShowAll").on("click", function(e) {
			e.preventDefault();

			if($(this).hasClass("active")) {
				$(this).removeClass("active").html("<span>Показать все</span>");
				$(".jsSimilarProductsListItem:not(:lt("+visibleSimilarProducts+"))").hide(200);
			} else {
				$(this).html("<span>Свернуть</span>").addClass("active");
				$(".jsSimilarProductsListItem").show(200).css("display", "inline-block");
			}
		});



	});
};


/** WEBPACK FOOTER **
 ** D:/phpstorm/szar/src/js/modules/similarProductsInit.js
 **/